'use strict';

module.exports = function () {
    var isLoggedIn = $('#customerLogged').data('customerlogged');

    // Add current page URL as returnUrl param to login links.
    // PRO uses rewritten routes like /acceso instead of Login-Show.
    var currentPath = window.location.pathname + window.location.search + window.location.hash;

    function isLoginHref(href) {
        if (!href) {
            return false;
        }

        var normalizedHref = href.toLowerCase();
        return normalizedHref.indexOf('login-show') !== -1
            || normalizedHref.indexOf('/acceso') !== -1
            || normalizedHref.indexOf('/account-login') !== -1;
    }

    function withReturnUrl(href) {
        if (!href || href.indexOf('returnUrl=') !== -1) {
            return href;
        }

        var separator = href.indexOf('?') !== -1 ? '&' : '?';
        return href + separator + 'returnUrl=' + encodeURIComponent(currentPath);
    }

    $('a[href]').each(function () {
        var href = $(this).attr('href');

        if (isLoginHref(href)) {
            $(this).attr('href', withReturnUrl(href));
        }
    });

    // 1. Logged In User validation for Add To Cart 
    $('body').on('click', '.add-to-cart .btn-add-to-cart, .add-to-cart-global', function (e) {
        var $btn = $(this);
        var $container = $btn.closest('.add-to-cart');
        // Fetch fresh status in case it changed via ajax (though unlikely without reload)
        var currentLoginStatus = $('#customerLogged').data('customerlogged');

        if (!currentLoginStatus) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            var $popover = $container.find('.login-popover-content');
            
            // Toggle visibility
            if ($popover.hasClass('d-none')) {
                // Hide other open popovers first
                $('.login-popover-content').not($popover).addClass('d-none');
                
                $popover.removeClass('d-none');
                
                // Hide when clicking outside
                setTimeout(function() {
                    $(document).on('click.loginPopover', function (ev) {
                        if (!$popover.is(ev.target) && $popover.has(ev.target).length === 0 && !$btn.is(ev.target)) {
                            $popover.addClass('d-none');
                            $(document).off('click.loginPopover');
                        }
                    });
                }, 0);
            } else {
                $popover.addClass('d-none');
                $(document).off('click.loginPopover');
            }
        }
    }); 

    // 2. Login Promo Toast 
    var $toast = $('#login-promo-toast');
    var isPDP = $('.product-detail').length > 0;
    var isConfirmation = $('.order-confirm').length > 0;

    if ($toast.length > 0 && !isPDP && !isConfirmation) {
        var promoStatus = window.sessionStorage.getItem('promoStatus'); // values: null, 'triggered', 'closed'

        if (!isLoggedIn && promoStatus !== 'closed') {
            
            var showToast = function() {
                // Check if sticky add-to-cart is present and visible (for mobile overlap issue)
                var $stickyBtn = $('.sticky-add-to-cart');
                if ($stickyBtn.length > 0 && $stickyBtn.is(':visible')) {
                    $toast.addClass('with-sticky-btn');
                } else {
                    $toast.removeClass('with-sticky-btn');
                }

                $toast.removeClass('d-none');
                setTimeout(function() { $toast.addClass('show'); }, 50);
                
                // Mark as triggered (so it persists on navigation if not closed)
                window.sessionStorage.setItem('promoStatus', 'triggered');

                // Close handler
                $toast.find('.close-toast').one('click', function() {
                    $toast.removeClass('show');
                    setTimeout(function() { $toast.addClass('d-none'); }, 500);
                    // Mark as explicitly closed (won't show again this session)
                    window.sessionStorage.setItem('promoStatus', 'closed');
                });
            };

            if (promoStatus === 'triggered') {
                // If previously shown but not closed, show again quickly (2s)
                setTimeout(showToast, 2000);
            } else {
                // First time: wait 30 seconds
                setTimeout(showToast, 30000);
            }
        }
    }
};
